/* ALPHAFLEX: one-tap add to cart from the size strip on product cards */
(function () {
  if (window.__afSizes) return;
  window.__afSizes = true;

  function flash(btn, msg) {
    btn.classList.add('has-error');
    btn.title = msg;
    setTimeout(function () { btn.classList.remove('has-error'); btn.removeAttribute('title'); }, 2500);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.af-size[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var fd = new FormData();
    fd.append('id', btn.dataset.variantId);
    fd.append('quantity', '1');
    if (cart && cart.getSectionsToRender) {
      fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      fd.append('sections_url', window.location.pathname);
      if (cart.setActiveElement) cart.setActiveElement(btn);
    }

    btn.classList.add('is-loading');
    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { flash(btn, data.description || data.message || 'Could not add to cart'); return; }
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'af-sizes', productVariantId: btn.dataset.variantId, cartData: data });
          }
        } catch (err) { /* optional */ }
        if (cart && cart.renderContents) cart.renderContents(data);
        else window.location = window.routes.cart_url;
      })
      .catch(function () { flash(btn, 'Network error'); })
      .finally(function () { btn.classList.remove('is-loading'); });
  }, true);
})();